import axios from 'axios'
import Vue from 'vue'
import store from '../store'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 显示加载状态
    store.dispatch('setLoading', true)
    // 可以在这里添加token等认证信息
    return config
  },
  error => {
    store.dispatch('setLoading', false)
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)
 
// 响应拦截器
service.interceptors.response.use(
  response => {
    store.dispatch('setLoading', false)
    return response.data
  },
  error => {
    store.dispatch('setLoading', false)
    console.error('响应错误:', error)
    return Promise.reject(error)
  }
)

Vue.prototype.$http = service

export default service